const handleHideProductForCollectionPageSearch = (lockElements) => {
    const hideHandles = lockElements
        .filter(el => el.hideProduct && el.handle)
        .map(el => el.handle);

    if (hideHandles.length === 0) return;
    
    const cssRules = hideHandles
        .map(handle => `
            #gf-products .spf-col-xl-3:has(a[href*="/products/${handle}"]) {
                display: none !important;
            }
            [id*=main-collection] #gf-products { visibility: visible !important;}
        `)
        .join('\n');

    // Inject CSS vào head
    const styleTagHideProduct = document.createElement('style');
    styleTagHideProduct.id = 'bss-style-hide-product'
    styleTagHideProduct.textContent = cssRules;
    // console.log(cssRules);
    
    // console.log(styleTagHideProduct, "styleTagHideProduct")
    document.head.appendChild(styleTagHideProduct);
};

if (window.Login) {
    const intervalId = setInterval(() => {
        if (window.Login.elements) {
            handleHideProductForCollectionPageSearch(window.Login.elements)
            clearInterval(intervalId)
        }
    }, 200);
}